// src/utils/formatCurrency.js

export function formatCurrency(amount) {
  // Convert the input to a number
  const num = Number(amount);

  // Check if the conversion resulted in a valid number
  if (isNaN(num)) return 'N/A';

  // Format the number with comma separators and conditional decimal places
  return `$${num.toLocaleString('en-US', { 
	minimumFractionDigits: 0, 
	maximumFractionDigits: 2 
  })}`;
}
